import LanguageSelect from 'components/LanguageSelect/LanguageSelect';
import NavMenu from 'components/NavMenu/NavMenu';
import { useCheckNotifications } from 'components/Notifications/hooks/useCheckNotifications';

import styles from './AppHeader.module.scss';
import LoggedUser from './LoggedUser/LoggedUser';
import NotificationsIndicator from './components/NotificationsIndicator/NotificationsIndicatior';

const AppHeader = () => {
  useCheckNotifications();

  return (
    <header>
      <div className={styles.headerContent}>
        <NavMenu />
        <div className={styles.extraContainer}>
          <LanguageSelect />
          <NotificationsIndicator />
          <LoggedUser />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
